var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Image } from '@inter-ikea-kompis/component-image';
import { Text } from '@inter-ikea-kompis/component-text';
import * as SkapaStyle from '@ingka/common-styles-webc';
import SummaryPageSecurityStyle from './SummaryPageSecurityStyle.js';
/**
 * The view for the Summary Page Security.
 */
class SummaryPageSecurity extends KompisElement {
    constructor() {
        super(...arguments);
        // The text for the title
        this.title = '';
        // The text for the description
        this.description = null;
        // The src string for the image
        this.imageSrc = null;
        // The alt text for the image
        this.imageAlt = null;
        // Highest heading in the summary page security tab.
        this.startHeadingsAtLevel = 4;
    }
    render() {
        return html `
			<style>
				${SummaryPageSecurityStyle.getStyle({ theme: this.theme })}
			</style>
			<div>${this.getTitle()} ${this.getDescription()} ${this.getSecurityImage()}</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-image', Image);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    getTitle() {
        if (!this.title) {
            return null;
        }
        const tagName = `h${this.startHeadingsAtLevel}`;
        const element = document.createElement(tagName);
        element.className = `no-margin title ${SkapaStyle.Text.classnames({ heading: { m: true } })}`;
        element.innerText = this.title;
        return element;
    }
    getDescription() {
        if (!this.description) {
            return null;
        }
        return html ` <kompis-text
			class="description"
			.theme="${this.theme}"
			.type="${ThemeFontStyleTypeEnum.bodyLarge}"
			>${this.description}</kompis-text
		>`;
    }
    getSecurityImage() {
        if (!this.imageSrc || !this.imageAlt) {
            return null;
        }
        return html `<kompis-image .alt="${this.imageAlt}" .src="${this.imageSrc}"></kompis-image>`;
    }
}
SummaryPageSecurity.eventTypes = [];
export default SummaryPageSecurity;
__decorate([
    property({ type: Object, required: true })
], SummaryPageSecurity.prototype, "theme", void 0);
__decorate([
    property({ type: String })
    // eslint-disable-next-line lit/no-native-attributes
], SummaryPageSecurity.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "description", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "imageSrc", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "imageAlt", void 0);
__decorate([
    property({ type: Number })
], SummaryPageSecurity.prototype, "startHeadingsAtLevel", void 0);
//# sourceMappingURL=SummaryPageSecurity.js.map